import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M19.5 19a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3Z"></path><path fill-rule="evenodd" d="M22.204 14.01A2 2 0 0 1 24 16v9l-.01.204a2 2 0 0 1-1.786 1.785L22 27H6l-.204-.01a2 2 0 0 1-1.785-1.786L4 25v-9a2 2 0 0 1 1.796-1.99L6 14h16l.204.01ZM6 25h16v-9H6v9Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M26.204 5.01A2 2 0 0 1 28 7v9l-.01.204a2 2 0 0 1-1.786 1.785L26 18h-1v-2h1v-5H10v2H8V7a2 2 0 0 1 1.796-1.99L10 5h16l.204.01ZM10 9h16V7H10v2Z" clip-rule="evenodd"></path></g>';
export var CreditCardOutlineSVG = function CreditCardOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CreditCardOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CreditCardOutlineSVG);